module.exports = __webpack_public_path__ + "static/media/postman.22f11067.jpg";